import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-chart-kpi-line',
    templateUrl: './chart-kpi-line.component.html',
    styleUrls: ['./chart-kpi-line.component.scss'],
    standalone: false
})
export class ChartKpiLineComponent {
  @Input() hc: any = {};
  @Input() chartData: any;
  @Input() metrics: any = {};
  lineChart: any;
  subHeading: string = '';
  constructor() {}

  ngOnInit(): void {
    this.fnSetSubHeading();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.lineChart = this.buildChart();
  }

  buildChart() {
    const chartData = this.chartData;
    const categories = chartData.labels.map((label: any) => label);
    const data = chartData.data.map((data: any) => data);

    return {
      chart: {
        type: 'spline',
      },
      title: {
        text: '',
      },
      subtitle: {
        text: '',
      },
      xAxis: {
        tickmarkPlacement: 'on',
        categories,
        allowDecimals: false,
        labels: {
          style: {
            color: '#545454B8',
            fontWeight: '600',
            fontSize: '10px',
            fontFamily: 'Nunito',
          },
        },
      },
      yAxis: {
        lineWidth: 1,
        tickAmount: 8,
        gridLineWidth: 0,
        title: '',
        lineColor: '#545454B8',
        labels: {
          style: {
            color: '#545454B8',
            fontWeight: '600',
            fontSize: '10px',
            fontFamily: 'Nunito',
          },
        },
      },
      legend: {
        symbolRadius: 0,
        itemStyle: {
          fontFamily: 'Nunito',
          fontWeight: 600,
        },
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: '<b>{series.name}</b>: {point.y}',
      },
      plotOptions: {
        series: {
          pointPlacement: 'on',
          lineWidth: 2,
          marker: {
            enabled: false,
            symbol: 'circle',
            radius: 3,
            states: {
              hover: {
                enabled: true,
              },
            },
          },
        },
      },
      series: data,
    };
  }

  fnSetSubHeading() {
    if (this.metrics && Object.keys(this.metrics).length !== 0) {
      this.subHeading =
        '(' + this.metrics.text + ': ' + this.metrics.value + ')';
    }
  }
}
